import React from 'react';
import { motion } from 'framer-motion';

const AnimatedButton = ({ 
  children, 
  primary = true,
  className = "",
  onClick,
  href,
  target,
  type = "button"
}) => {
  const buttonClasses = primary 
    ? `btn-primary ${className}`
    : `btn-secondary ${className}`;
  
  const buttonVariants = {
    initial: { scale: 1 },
    hover: { 
      scale: 1.03,
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)"
    },
    tap: { scale: 0.98 }
  };
  
  const buttonContent = (
    <>
      <span className="z-10 relative">{children}</span>
      <motion.span 
        className={`absolute inset-0 ${primary ? 'bg-white' : 'bg-primary-500'} rounded-xl opacity-0`}
        initial={{ opacity: 0, scale: 0.8 }}
        whileHover={{ opacity: 0.1, scale: 1 }}
        transition={{ duration: 0.3 }}
      />
      
      {/* Subtle glow effect */}
      <motion.span 
        className="absolute -inset-1 bg-white rounded-xl opacity-0 blur-md"
        initial={{ opacity: 0 }}
        whileHover={{ opacity: 0.2 }}
        transition={{ duration: 0.4 }}
      />
    </>
  );
  
  // If href is provided, render as a link
  if (href) {
    return (
      <motion.a 
        href={href}
        target={target}
        className={`${buttonClasses} relative overflow-hidden`}
        variants={buttonVariants}
        initial="initial"
        whileHover="hover"
        whileTap="tap"
        transition={{ duration: 0.3 }}
        onClick={onClick}
      >
        {buttonContent}
      </motion.a>
    );
  }
  
  // Otherwise render as a button
  return (
    <motion.button 
      type={type}
      className={`${buttonClasses} relative overflow-hidden`}
      variants={buttonVariants}
      initial="initial"
      whileHover="hover"
      whileTap="tap"
      transition={{ duration: 0.3 }}
      onClick={onClick}
    >
      {buttonContent}
    </motion.button>
  );
};

export default AnimatedButton;